// @flow

import * as React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Loadable from 'react-loadable';

import type { CommonActionProps } from './types.actions';
import type { GridItem } from '../../types';
import ToggleController from '../../controllers/ToggleController';
import ButtonAction from './ButtonAction';
import LoadingModule from '../LoadingModule';
import { DesktopView, MobileView } from '../../config/mediaQuery';
import { ActionsContext } from '../../context/actions.context';

const AsyncMOBOModule = Loadable({
  loader: () => import('../../modules/MOBO'),
  loading: LoadingModule,
});

type Props = {
  item: GridItem,
  onItemUpdatedUpdateParentCollection: any,
  onItemAddedParentCollection: any,
  items?: Array<GridItem>,
  activeOrder: any,
  selectedOrderType?: string,
};

class MOBOAction extends React.Component<CommonActionProps & Props> {
  static defaultProps = {
    size: 'xsmall',
  };
  static contextType = ActionsContext;

  shouldComponentUpdate(nextProps: CommonActionProps & Props) {
    if (
      nextProps.disabled !== this.props.disabled
    ) {
      return true;
    }

    return false;
  }

  render() {
    const { setFullScreenView, allScreens } = this.context;
    const moboView = (
      <AsyncMOBOModule
        isFullPage={false}
        selectedRow={this.props.item}
        onItemUpdatedUpdateParentCollection={
          this.props.onItemUpdatedUpdateParentCollection
        }
        onItemAddedParentCollection={this.props.onItemAddedParentCollection}
        items={this.props.items}
        selectedOrderType={this.props.selectedOrderType}
        activeOrder={this.props.activeOrder}
        orderModuleRefetch={this.props.moduleRefetch}
      />
    )
    return (
      <ToggleController>
        {({ onToggleVisibility, visible }) => (
          <React.Fragment>
            <DesktopView>
              <ButtonAction
                bsSize={this.props.size}
                disabled={this.props.disabled}
                onClick={onToggleVisibility}
              >
                <Glyphicon glyph="chevron-right" /> MOBO
              </ButtonAction>
            </DesktopView>
            <MobileView>
              <button onClick={onToggleVisibility}>
                <img src='assets/mobo.svg' alt='mobo icon' /> MOBO
              </button>
            </MobileView>
            <DesktopView>
              <Modal bsSize="large" show={visible} onHide={onToggleVisibility}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    MOBO -{' '}
                    {this.props && this.props.item && this.props.item.AcctName}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>{visible && moboView}</Modal.Body>
                <Modal.Footer>
                  <Button onClick={onToggleVisibility}>Close</Button>
                </Modal.Footer>
              </Modal>
            </DesktopView>
            <MobileView>
              {setFullScreenView && !allScreens.find(o => o.view === moboView) && 
                setFullScreenView(visible ? moboView : null, 'MOBO', onToggleVisibility)}
            </MobileView>
          </React.Fragment>
        )}
      </ToggleController>
    )
  }
}

export default MOBOAction
